import { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Redirect } from 'react-router-dom';

import { getMobileOperatingSystem, getTeachSubscriptionNumClasses, moveToScrollToElem, userHasSubscription } from '../../utils';

import BottomMenu from '../../components/BottomMenu';

import SectionHeader from '../../components/Utils/SectionHeader';
import { loadSubscriptions, TEACHERPRODUCTS } from '../../modules/subscription';
import { unlockScreen } from '../../utils/screen';

import { recordPageGA } from '../../modules/ga';

import { useHistory } from "react-router-dom";

import '../Learn/index.less';
import '../Teach/index.less';
import './index.less';

import { DeploymentUnitOutlined } from '@ant-design/icons';
import ModalLoader from '../../components/Course/ModalLoader';
import SubscriptionOptions from '../../components/Subscription/SubscriptionOptions';
import CompetitionsList from '../../components/teach/CompetitionsList';
import StudentCompetitionDetails from '../../components/teach/StudentCompetitionDetails';
import { t } from '../../languages';
import { loadAClass } from '../../modules/aclass';
import { addStudentToCompetition, loadCompetition, loadStudentCompetitions, sendCompetitionResponse } from '../../modules/competition';
import { switchToFullscreen } from '../../modules/utils';

const HASSUBSCRIPTION = false;
const os = getMobileOperatingSystem().toLocaleLowerCase();

const AskForTeacherSubscription = ({ lang, max }) => {
  return (
    <div className="ask-for-teacher-subscription" >
      <h5 style={{ textAlign: 'center' }}>{t(lang, 'classLimitReached')}</h5>
      <SubscriptionOptions lang={'lang'} forTeach={true} hasTeacherSubscription={false} />
      <br />
      <br />
      <br />
      <br />
    </div >
  );
}

const MiniTournament = ({
  user,
  results,
  lang,
  isLoading,
  transactions,
  products,
  loadSubscriptions,

  classes, currentClass,
  loadAClass,

  competitions, currentCompetition,
  loadStudentCompetitions, loadCompetition, sendCompetitionResponse, addStudentToCompetition
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalOption, setModalOption] = useState(null);
  const [hasSubscription, setHasSubscription] = useState(HASSUBSCRIPTION);
  const [myPurchasedProducts, setMyPurchasedProducts]: [any, any] = useState(null);

  const history = useHistory();

  useEffect(() => {
    // console.log('MiniTournament.useEffect[]....');
    recordPageGA('/minitournament');

    if (user) {
      if (user.teacher && user.joinedToClass) {
        loadStudentCompetitions(user.teacher, user.joinedToClass);
        // loadAClass(user.joinedToClass);
      }
    }

    if (!products) loadSubscriptions();

  }, []);

  const _evalHasSubscription = () => {
    let { hasSubscription, products } = userHasSubscription(transactions, user);

    setHasSubscription(hasSubscription);
    setMyPurchasedProducts(products);
  }

  useEffect(() => {
    // console.log('useEffect[transactions]...');
    if (transactions) {
      _evalHasSubscription();
    }
  }, [transactions]);

  useEffect(() => {
    // console.log('useEffect[user]...');
    if (user) {
      _evalHasSubscription();
    }
  }, [user]);


  useEffect(() => {
    if (results) {
      // console.log('MiniTournament useEffect[results]:', results.current);
      moveToScrollToElem(results.current);
      // moveToScrollPoition();
    }
  }, [results]);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (modalVisible) {
        setModalVisible(false);
        return false; // Prevent navigation
      }
    });

    return () => {
      unblock();
    };
  }, [modalVisible, setModalVisible, history]);

  useEffect(() => {
    if (!modalVisible) unlockScreen();
  }, [modalVisible]);

  /* Handlers */
  const handleCancel = e => {
    setModalVisible(false);
  };

  const handleOk = e => {
    setModalVisible(false);
  };

  /* Competition Handlers */

  const handleCompetitionClicked = aComp => {
    // console.log('MiniTournament.handleCompetitionClicked:', aComp);
    setModalTitle(<h2><DeploymentUnitOutlined className="class-icon" /> {aComp.name}</h2>);
    setModalOption('competitionDetails');
    loadCompetition(aComp.id);
    setModalVisible(true);

    switchToFullscreen();
  }

  const handleExpireTime = (eid) => {
    loadCompetition(currentCompetition.id);
  }

  const divStyle: any = {
    // height: `${innerHeight - 53}px`,
    overflowX: 'hidden',
    overflowY: 'scroll',
    paddingBottom: '53px'
  };

  // console.log('MiniTournament: classes:', classes, currentClass);

  if (!user) return <Redirect to="/profile/login" />;
  else {
    let modalContent = null;

    // const hasTeacherSubscription = containsTeachSubscription(myPurchasedProducts, TEACHERPRODUCTS[os]);
    const { hasTeacherSubscription, maxNumClasses } = getTeachSubscriptionNumClasses(myPurchasedProducts, TEACHERPRODUCTS[os]);
    // console.log('MiniTournament: myPurchasedProducts:', myPurchasedProducts, 'hasSubscription:', hasSubscription, 'hasTeacherSubscription:', hasTeacherSubscription, 'classes:', classes, 'maxNumClasses:', maxNumClasses);

    if (modalOption === 'competitionDetails' && currentCompetition) {
      const theClass = classes.find(aC => aC.id == currentCompetition.class);
      modalContent = (<StudentCompetitionDetails isLoading={isLoading} lang={lang} theCompetition={currentCompetition} theClass={theClass} onExpireTime={handleExpireTime} user={user} addStudent={addStudentToCompetition} onSaveResponse={sendCompetitionResponse} />);
    }

    return (
      <section className='MiSoroban'>
        <div style={divStyle} className="learn teach minitournament">

          <div className='mis-wrapper'>
            <SectionHeader section={'competitions'} />
            <div className='teach-body'>
              {competitions && competitions.length ? <CompetitionsList lang={lang} competitions={competitions} classes={classes} onCompetitionClick={handleCompetitionClicked} /> : <>{t(lang, 'noopencompetition')}</>}

            </div>
          </div>
        </div>

        <ModalLoader
          title={modalTitle}
          visible={modalVisible}
          handleOk={handleOk}
          handleCancel={handleCancel}
          content={modalContent}
          className="exercise-modal teach-modal minitournament"

        />

        <BottomMenu section={'minitournament'} />
      </section>
    );
  }
};

const mapStateToProps = ({ user, aclass, subscription, competition }) => ({
  user: user.user,
  isLoading: aclass.isFetching || competition.isFetching,
  lang: user.lang,
  products: subscription.products,
  transactions: subscription.transactions,
  classes: aclass.data,
  currentClass: aclass.current,
  competitions: competition.data,
  currentCompetition: competition.current,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadSubscriptions,

      loadAClass,

      loadStudentCompetitions,
      loadCompetition,
      sendCompetitionResponse,
      addStudentToCompetition
    },
    dispatch
  );

export default memo(connect(mapStateToProps, mapDispatchToProps)(MiniTournament));
